<template>

  <div class="large_social_container">
    
    <h4>Share</h4>

    <!-- HIDDEN INPUT FOR LINK SHARING -->
    <input type="text" :value="window_url" id="link_share_text">

    <div class="social_button_container">
     
      <div class="container">

        <div class="row">
          <div class="col-6">
            
            <div class="fb_share_button social_button"
            @click="share_fb"
            >
              <font-awesome-icon :icon="{prefix: 'fab', iconName: 'facebook-square'}"></font-awesome-icon>
            </div>

          </div>
          <div class="col-6">
            
            <div class="tw_share_button social_button"
            @click="share_tw"
            >
              <font-awesome-icon :icon="{prefix: 'fab', iconName: 'twitter-square'}"></font-awesome-icon>
            </div>

          </div>
        </div>

        <div class="row">
          <div class="col-6">
            
            <div class="email_share_button social_button"
            @click="share_email"
            >
              <font-awesome-icon :icon="{prefix: 'fas', iconName: 'envelope-square'}"></font-awesome-icon>
            </div>

          </div>
          <div class="col-6">
            
            <div class="link_share_button social_button"
            @click="share_link"
            >
              <font-awesome-icon :icon="{prefix: 'fas', iconName: 'link'}"></font-awesome-icon>

              <transition
              name="" 
              mode="out-in"
              enter-active-class="animated bounceIn faster" 
              leave-active-class="animated bounceOut faster" 
              >
                <div class="link_copy_message"
                v-if="link_copied"
                >
                  Link copied to clipboard
                </div>
              </transition>

            </div>

          </div>
        </div>

      </div>

    </div>

  </div>

</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { 
  faEnvelopeSquare,
  faLink
} from '@fortawesome/free-solid-svg-icons';
import { 
  faFacebookSquare,
  faTwitterSquare
} from '@fortawesome/free-brands-svg-icons';
library.add(
  faFacebookSquare,
  faTwitterSquare,
  faEnvelopeSquare,
  faLink
);

export default {
  name: 'large_social_share',
  props: [
    'share_type',
    'contest'
  ],
  data () {
    return {
      window_url: window.location.href,
      fb_app_id: '497104900789770',
      link_copied: false
    }
  },
  methods: {
    share_fb: function() {
      // let share_url = 'https://www.facebook.com/dialog/share?app_id='+this.fb_app_id+'&display=popup&href='+escape(window.location.href)+'&redirect_uri='+escape('https://projects.dayton.com/best_of_dayton/');
      let share_url = 'https://www.facebook.com/sharer/sharer.php?u='+escape(window.location.href)+'&t='+document.title;

      window.open(share_url, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=400,width=600');

      this.fire_ga_event('Facebook Share');
    },
    share_tw: function() {
      let share_text = escape('Submit your '+this.share_type+' for "'+this.contest.label+'" for Dayton.com\'s 2018 Best of Dayton contest.');

      window.open("https://twitter.com/share?url="+escape(window.location.href)+"&text="+share_text, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=400,width=600');

      this.fire_ga_event('Twitter Share');
    },
    share_email: function() {
      let subject = "Best of Dayton: Nominate for "+this.contest.label;
      let body = window.location.href;

      window.open('mailto:?subject='+subject+'&body='+body, '_top', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600');

      this.fire_ga_event('Email Share');
    },
    share_link: function() {
      let vm = this;

      // RESET STATUS MSG
      vm.toggle_link_message(false);

      let link_text = document.getElementById('link_share_text');
      link_text.select();
      document.execCommand("copy");
      console.log('copied to clipboard: ');

      vm.toggle_link_message(true);

      this.fire_ga_event('Link Share');

      // SET TIMEOUT FOR MSG
      setTimeout(function() {
        vm.toggle_link_message(false);
      }, 2000);
    },
    toggle_link_message: function(specific_value) {
      if(typeof specific_value != 'undefined') {
        this.link_copied = specific_value;
      }
      else {
        this.link_copied = !this.link_copied;
      }
    },
    fire_ga_event(event_action) {
      let vm = this;
      
      // FIRE GA EVENT
      vm.$ga.event({
        eventCategory: 'Sharing',
        eventAction: event_action,
        eventLabel: this.window_url
      })
    }
  },
  components: {
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '@/styles/global_styles.scss';

.large_social_container {
  
  margin-bottom: 2em;

  h4 {
    text-align: center;
    padding: 0.6rem 0;
    text-transform: uppercase;
    background: #ddd;
    border-top: solid 4px #ccc;
    border-bottom: solid 4px #ccc;
  }

  #link_share_text {
    position: absolute;
    left: -9999px;
    top: -9999px;
  }

  .social_button_container {
    width: 80%;
    margin: 0 auto;

    .social_button {
      width: 100%;
      text-align: center;
      font-size: 8em;
      line-height: 1.4em;
      color: $dcom-orange;
      cursor: pointer;
    }

    .link_copy_message {
      font-size: 1rem;
      line-height: 1rem;
      position: absolute;
      top: 40%;
      width: 100%;
      z-index: 10;
      background: rgba(255,255,255,0.8);
      padding: 1rem 0;
      font-weight: bold;
      color: #666;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/social/large_social_share.vue